// The programme's own site, linked from the Executive Sponsor Program group of the help panel.
export const ESP_PORTAL_URL =
  'https://hp.sharepoint.com/sites/coexecutivesponsorprogram/sitepages/index.aspx?env=WebView'
